<template>
	<div class="col-md-8">
		<div v-if="errors" class="alert alert-warning alert-dismissible fade show shadow-sm" :style="'width: -webkit-fill-available'" role="alert">
			<div v-html="errors"></div>
			<button type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">×</span>
			</button>
		</div>
		<div class="mg-t-20 mg-b-20 mg-lg-b-25 mg-xl-b-30">
			<form @submit.prevent="sendMessage" @keydown="form.onKeydown($event)">
				<div class="form-row">
					<div class="form-group col-12">
						<label>
							Topic
							<span>*</span>
						</label>
						<select v-model="form.topic" class="form-control custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('topic') }">
							<option selected :value="null" disabled>Select an option</option>
							<option v-for="(topic, index) in topics" :value="topic" :key="index">{{ topic }}</option>
						</select>
						<has-error :form="form" field="topic"></has-error>
					</div>
					<div class="form-group col-md-12">
						<label class="d-block">
							Subject
							<span>*</span>
						</label>

						<div class="custom-control custom-radio d-inline mr-3" v-for="(subject, index) in subjects" :key="index">
							<input v-model="form.subject" type="radio" :id="index" :value="subject" class="custom-control-input" />
							<label class="custom-control-label" :for="index">{{ subject }}</label>
						</div>

						<has-error :form="form" field="subject"></has-error>
					</div>
				</div>

				<div class="form-row">
					<div class="form-group col-12">
						<label>
							Message
							<span>*</span>
						</label>
						<textarea v-model="form.message" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('message') }" rows="8" placeholder="Message body" required></textarea>
						<has-error :form="form" field="message" class="d-block"></has-error>
					</div>
				</div>

				<button-component :busy="form.busy" :label="'Send Message'" :label-loading="'Sending...'" :button-class="'btn btn-default shadow-sm btn-block'"></button-component>
			</form>
		</div>
	</div>
</template>

<style scoped>
span {
	color: red;
}

@media (max-width: 425px) {
	.mr-3 {
		margin-right: 10px !important;
	}
}
</style>

<script>
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			errors: null,
			form: new Form({
				topic: this.$route.query.topic ? this.$route.query.topic : null,
				subject: 'General Enquiry',
				message: this.$route.query.message ? this.$route.query.message : null,
				customer: this.$store.getters.company.external_client_id,
				type: 'send',
			}),
		};
	},
	computed: {
		...mapGetters({
			topics: 'message_topics',
			subjects: 'message_subjects',
		}),
	},
	methods: {
		sendMessage() {
			this.form
				.post('/api/messages')
				.then(({ data }) => {
					this.$router.push({
						name: `messages.sent.view`,
						params: { id: data.data.messages.id },
					});
				})
				.catch(() => {
					this.errors = this.form.errors.get('error');
				});
		},
	},
};
</script>
